module.exports = {
    collectionZone: 'Collection Zone',
};



// WEBPACK FOOTER //
// ./src/shop/trolley/trolley-source.js